import { createFileRoute } from "@tanstack/react-router";
import { CABINET_HOME_COPY } from "@/components/partners/cabinet-home-copy";
import { tutorCabinetHead } from "@/components/partners/tutor-cabinet-head";
import { TutorCabinetEditPage } from "@/components/partners/TutorCabinetPage";

// «Изменить анкету» (az) — отдельный экран кабинета. «_» после me — не вкладывать
// в главную кабинета: у неё нет <Outlet/>. noindex, в sitemap нет.
export const Route = createFileRoute("/az/tutors/me_/edit")({
  head: () => tutorCabinetHead("az", CABINET_HOME_COPY.az.editTitle),
  component: () => <TutorCabinetEditPage lang="az" />,
});
